var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpeechRecognition(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-7faeac5f-6c46-43ed-b85c-73c4f5610c90",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 60,
    viewBox: "0 0 100 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m60.261,31.406v-10.186c0-5.635-4.585-10.22-10.301-10.22-5.636,0-10.221,4.585-10.221,10.22v10.186c0,5.139,3.816,9.392,8.761,10.104v4.49h-4.896c-.828,0-1.5.671-1.5,1.5s.672,1.5,1.5,1.5h12.793c.828,0,1.5-.671,1.5-1.5s-.672-1.5-1.5-1.5h-4.896v-4.49c4.945-.712,8.761-4.965,8.761-10.104Zm-17.521,0v-3.708h14.521v3.708c0,3.981-3.239,7.221-7.221,7.221h-.08c-3.981,0-7.221-3.239-7.221-7.221Z",
    style: {
      fill: "#fff"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeechRecognition);
export default __webpack_public_path__ + "static/media/SpeechRecognition.a7f370d6c725c0ff68a46d03bf828070.svg";
export { ForwardRef as ReactComponent };